<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TdZgT4/tc-custom/9780226308128.jpg?1732132329830" alt="This image is the cover for the book Mind of the Middle Ages"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mind of the Middle Ages
      </h1>
      <p class="bookDescription body article font2">
        <p>"This is the third edition of a near standard survey of the intellectual life of the age of faith. Artz on the arts, as on philosophy, politics and other aspects of culture, makes lively and informative reading."—<i>The Washington Post</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Frederick B. Artz
      </h2>
      
      <p class="authorDescription body article">Please fill in author biography</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Pres
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?763695df